import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import FreshidLogin from './Login';
import FreshidLogout from './Logout';
import FreshidSSOSuccess from './SSOSuccess';
import FreshidSignupSuccess from './SignupSuccess';

const FreshidRoutes = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${path}/token-login/:authToken`}>
        <FreshidSignupSuccess />
      </Route>
      <Route exact path={`${path}/oauth/success`}>
        <FreshidSSOSuccess />
      </Route>
      <Route exact path={`${path}/logout`}>
        <FreshidLogout />
      </Route>
      <Route exact path={`${path}/login`}>
        <FreshidLogin />
      </Route>
    </Switch>
  );
};

export default FreshidRoutes;
